import type { Dispatch, SetStateAction } from 'react';

import Button from '@/components/Button';
import Text from '@/components/Text';

import { AuthPageEnum } from '../AuthEnum';
import AuthDialogTitle from './AuthDialogTitle';

const AuthDialogTitleMoveToLogIn = ({
  setCurrentAuthPage,
  isLogInButtonHidden,
}: {
  setCurrentAuthPage: Dispatch<SetStateAction<AuthPageEnum>>;
  isLogInButtonHidden?: boolean;
}) => {
  return (
    <AuthDialogTitle title="Create an account">
      {!isLogInButtonHidden && (
        <Text
          variant="body"
          className="flex flex-row text-neutral-1000 opacity-70"
        >
          Already have an account?&nbsp;
          <Button
            variant="unstyled"
            size="xs"
            onClick={() => setCurrentAuthPage(AuthPageEnum.LOGIN_PROVIDERS)}
            className="!font-normal text-secondary-500"
          >
            Log in
          </Button>
        </Text>
      )}
    </AuthDialogTitle>
  );
};

export default AuthDialogTitleMoveToLogIn;
